//Payment url param
export const PayerParam = {
  lang: "Lang",
  redirect: "Redirect",
};
export const PaymentParam = {
  MReferenceID: "MReferenceID",
  FPayTrackID: "FPayTrackID",
  KnetPaymentID: "KnetPaymentID",
  KnetRefID: "KnetRefID",
  KnetTransID: "KnetTransID",
  MigsTransactionNo: "MigsTransactionNo",
  MigsReceiptNo: "MigsReceiptNo",
  date:"date",
};
export const PaymentMethodConst = {
  KNET: "KNET",
  Credit_Card: "CREDIT CARD",
};



// WEBPACK FOOTER //
// ./src/modules/Payer/PayerConstants.js